module.exports = __webpack_public_path__ + "static/img/info_button3.23c85b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_button3.png
// module id = lVLF
// module chunks = 4